var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWatchHeartRate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1673 31.6663H25.834C29.7173 31.6663 31.6673 29.7163 31.6673 25.833V14.1663C31.6673 10.283 29.7173 8.33301 25.834 8.33301H14.1673C10.284 8.33301 8.33398 10.283 8.33398 14.1663V25.833C8.33398 29.7163 10.284 31.6663 14.1673 31.6663Z",
    stroke: "url(#paint0_linear_2527_86664)",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6654 3.33301H13.332",
    stroke: "url(#paint1_linear_2527_86664)",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6654 36.667H13.332",
    stroke: "url(#paint2_linear_2527_86664)",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20 23.3346V16.668",
    stroke: "url(#paint3_linear_2527_86664)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25 23.3343V20.001",
    stroke: "url(#paint4_linear_2527_86664)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15 23.3346V21.668",
    stroke: "url(#paint5_linear_2527_86664)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2527_86664",
    x1: 20.0007,
    y1: 8.33301,
    x2: 20.0007,
    y2: 31.6663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.47
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2527_86664",
    x1: 19.9987,
    y1: 3.33301,
    x2: 19.9987,
    y2: 4.33301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.47
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2527_86664",
    x1: 19.9987,
    y1: 36.667,
    x2: 19.9987,
    y2: 37.667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.47
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2527_86664",
    x1: 20.5,
    y1: 16.668,
    x2: 20.5,
    y2: 23.3346,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.47
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2527_86664",
    x1: 25.5,
    y1: 20.001,
    x2: 25.5,
    y2: 23.3343,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.47
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2527_86664",
    x1: 15.5,
    y1: 21.668,
    x2: 15.5,
    y2: 23.3346,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.47
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWatchHeartRate);
export default __webpack_public_path__ + "static/media/watchHeartRate.efefa24988907c9f3efec5d54149d931.svg";
export { ForwardRef as ReactComponent };